/*  camelcase */
export default {
    name: ['required', 'trim', 'string'],
    street: ['required', 'trim', 'string'],
    city_sync_id: ['required', 'trim', 'string'],
    restaurant: ['required', 'trim', 'string'],
    house_number: ['required', 'trim', 'string'],
    delivery_terminal_id: ['required', 'trim', 'string'],
    kitchen_code: ['required', 'trim', 'string'],
};